import { ISurveyPlugin } from '../../plugin-host/plugin.interface';

export const nsec: ISurveyPlugin = {
  id: 'sec-auto-calculator',
  name: 'SEC Calculator (A9 Inserter)',
  runOnce: true,
  config: {
    targetQuestionName: 'NSEC',
    targetVariable: 'SEC_CODE',
  },
  variablesSchema: [
    {
      key: 'SEC_CODE',
      type: 'number',
    },
  ],
  html: `
    <div id="sec-injector-wrapper" style="background: #ffffff; border: 1px solid #e2e8f0; padding: 24px; border-radius: 12px; margin-bottom: 24px; font-family: sans-serif; display:none; box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);">
      <div style="margin-bottom: 20px;">
        <label style="display:block; font-size: 14px; font-weight: 600; color: #334155; margin-bottom: 8px;">1. Educational qualification of the Chief Wage Earner:</label>
        <select id="inj-edu-select" style="width: 100%; padding: 10px; border-radius: 8px; border: 1px solid #cbd5e1; background-color: #f8fafc; font-size: 15px;">
          <option value="">-- Select Education --</option>
          <option value="1">Illiterate</option>
          <option value="2">School: Up to 4 years / literate but no formal training</option>
          <option value="3">School: up to 4 years</option>
          <option value="4">School: 5-9 years</option>
          <option value="5">SSC/HSC</option>
          <option value="6">Some college (Ind. diploma) but not graduate</option>
          <option value="7">Graduate/post-Graduate General (BA, B.Sc., etc.)</option>
          <option value="8">Graduate/Post-Graduate Professional (BE, MBA, etc.)</option>
        </select>
      </div>
      <div style="margin-bottom: 15px;">
        <label style="display:block; font-size: 14px; font-weight: 600; color: #334155; margin-bottom: 12px;">2. Which of these items do you have at home?</label>
        <div id="inj-durables-grid" style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;"></div>
      </div>
      <div id="inj-feedback-box" style="margin-top: 15px; padding: 12px; border-radius: 8px; background: #eff6ff; border: 1px solid #dbeafe; display: flex; justify-content: space-between; align-items: center;">
        <span style="font-size: 14px; color: #1e40af; font-weight: 500;">Calculated SEC:</span>
        <span id="inj-result-label" style="font-size: 18px; font-weight: 800; color: #2563eb;">-</span>
      </div>
    </div>
  `,
  hooks: {
    onPageInit: `
      // 1. Setup constants and references
      const targetName = context.config.targetQuestionName;
      const wrapper = context.container.querySelector('#sec-injector-wrapper');
      const eduSelect = wrapper.querySelector('#inj-edu-select');
      const resultLabel = wrapper.querySelector('#inj-result-label');
      
      // Matrix based on Education (rows 1-8) and Durable Count (cols 0-9+)
      const lookup = { 
        1: ['E3','E2','E1','D2','D1','C2','C1','C1','B1','B1'], 
        2: ['E2','E1','E1','D2','C2','C1','B2','B1','A3','A3'], 
        3: ['E2','E1','E1','D2','C2','C1','B2','B1','A3','A3'], 
        4: ['E2','E1','D2','D1','C2','C1','B2','B1','A3','A3'], 
        5: ['E2','E1','D2','D1','C1','B2','B1','A3','A3','A2'], 
        6: ['E2','D2','D1','C2','C1','B1','A3','A3','A2','A2'], 
        7: ['E1','D2','D1','C2','B2','B1','A3','A2','A2','A1'], 
        8: ['D2','D2','D1','C2','B2','B1','A3','A2','A2','A1'] 
      };
      
      const secMap = {'A1':1,'A2':2,'A3':3,'B1':4,'B2':5,'C1':6,'C2':7,'D1':8,'D2':9,'E1':10,'E2':11,'E3':12};

      // 2. Calculation Logic: Updates the visible label AND the hidden A9 textarea
      const updateSEC = () => {
        const edu = eduSelect.value;
        const checked = wrapper.querySelectorAll('.inj-check:checked').length;
        const targetInput = document.querySelector(\`[name='\${targetName}']\`);

        if (edu) {
          const label = lookup[edu][Math.min(checked, 9)];
          resultLabel.innerText = label;
          context.currentSecCode = secMap[label];
          
          // CRITICAL: Live update of the A9 Textarea value
          if (targetInput) {
            targetInput.value = label;
            // Dispatch input event so Angular/Engine detects the change
            targetInput.dispatchEvent(new Event('input', { bubbles: true }));
          }
        } else {
          resultLabel.innerText = '-';
          context.currentSecCode = null;
          if (targetInput) {
            targetInput.value = '';
            targetInput.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      };

      // 3. Injection Logic: Moves the plugin UI above the target question
      const attemptInjection = () => {
        const target = document.querySelector(\`[name='\${targetName}']\`) || document.getElementById(targetName);
        if (!target) return false;

        const qBox = target.closest('lib-element') || target.closest('.element-container') || target.parentNode;
        if (qBox && wrapper) {
          qBox.parentNode.insertBefore(wrapper, qBox);
          wrapper.style.display = 'block';
          
          target.style.display = 'none';
          const labels = document.querySelectorAll(\`label[for='\${targetName}']\`);
          labels.forEach(l => l.style.display = 'none');
          return true;
        }
        return false;
      };

      // 4. Observer: Watches for the question if it hasn't loaded yet
      if (!attemptInjection()) {
        const observer = new MutationObserver(() => {
          if (attemptInjection()) observer.disconnect();
        });
        observer.observe(document.body, { childList: true, subtree: true });
        context.secObserver = observer;
      }

      // 5. Build Durables Grid
      const durables = ['Electricity Connection', 'Ceiling Fan', 'LPG Stove', 'Two-Wheeler', 'Colour TV', 'Refrigerator', 'Washing Machine', 'PC/Laptop', 'Car/Jeep/Van' , 'Agricultural Land'];
      const grid = wrapper.querySelector('#inj-durables-grid');
      
      if (grid.children.length === 0) {
        durables.forEach((item) => {
          const lbl = document.createElement('label');
          lbl.style.cssText = 'font-size:13px; color:#475569; cursor:pointer; display:flex; align-items:center; gap:8px;';
          lbl.innerHTML = \`<input type="checkbox" class="inj-check" style="width:16px; height:16px; accent-color:#2563eb;"><span>\${item}</span>\`;
          grid.appendChild(lbl);
        });
      }

      // 6. Event Listener: Simple delegation for all internal plugin inputs
      wrapper.addEventListener('change', (e) => {
        if (e.target.id === 'inj-edu-select' || e.target.classList.contains('inj-check')) {
          updateSEC();
        }
      });

      // Initial run to sync state
      updateSEC();
    `,
    onBeforeSubmit: `
      // Clean up observer to prevent memory leaks
      if (context.secObserver) context.secObserver.disconnect();
      
      const wrapper = context.container.querySelector('#sec-injector-wrapper');
      if (wrapper && wrapper.style.display !== 'none') {
        const edu = wrapper.querySelector('#inj-edu-select').value;
        if (!edu) {
          context.setInvalid('Please select the Chief Wage Earner\\'s education to calculate SEC.');
          return;
        }
        // Metadata storage backup
        context.setVariable(context.config.targetVariable, context.currentSecCode || 0);
      }
    `,
    onCleanup: `
      if (context.secObserver) context.secObserver.disconnect();
    `,
  },
  version: '1.0.3',
  configSchema: {},
};